import React, { useState } from "react";
import * as Animate from "react-reveal";

const BROCHURE_URL =
  "https://drive.google.com/file/d/1gcNMbCEL30s3g8Y9vZaMbfkBDntihi7e/view?usp=sharing";

const modules = [
  {
    month: "Month 1",
    title: "Strategic Leadership & Business Thinking",
    copy:
      "Build the judgement to read a business clearly, make better decisions and lead beyond your current function.",
    output: "Leadership and business diagnosis brief",
  },
  {
    month: "Month 2",
    title: "Growth, Customers & Organizational Performance",
    copy:
      "Connect customer insight, growth thinking and team performance to the outcomes a business needs.",
    output: "Growth and performance plan",
  },
  {
    month: "Month 3",
    title: "Finance, Execution & Risk Management",
    copy:
      "Understand the financial logic behind decisions and turn strategy into accountable execution.",
    output: "Financial impact and execution case",
  },
  {
    month: "Month 4 · Choose your track",
    title: "Specialization Tracks",
    copy:
      "Go deeper through one of six specialization tracks aligned to your leadership or business goals.",
    output: "Specialization project",
  },
  {
    month: "Month 5",
    title: "AI, Innovation & Digital Transformation",
    copy:
      "Explore how AI, automation and emerging technology can improve productivity, performance and business models.",
    output: "AI opportunity assessment",
  },
];

const MBACurriculumSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      className="hire-grid-bg text-white py-16 md:py-24 lg:py-28 px-4"
      id="curriculum"
    >
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-mba-curriculum gap-10 lg:gap-16">
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 font-poppins text-secondary text-sm font-extrabold tracking-widest uppercase mb-5">
              <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
              Program curriculum
            </p>
            <h2 className="font-poppins text-white font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight mb-5">
              Five months. One useful business output at every stage.
            </h2>
            <p className="font-poppins text-blue-100 text-sm leading-loose max-w-sm mb-7">
              The program moves from leadership and growth through finance,
              specialization and AI—then brings the work together in a capstone.
            </p>
            <a
              href={BROCHURE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary bg-secondary custom-btn px-7 py-4 text-center rounded-xl inline-flex items-center gap-3 font-poppins font-bold text-sm focus:outline-none"
            >
              Download the full brochure <span aria-hidden="true">↓</span>
            </a>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="grid gap-2.5">
            {modules.map((module, index) => {
              const isOpen = openIndex === index;
              return (
                <article
                  key={module.month}
                  className={`rounded-2xl border overflow-hidden transition-colors ${
                    isOpen
                      ? "bg-white/[0.12] border-secondary/70"
                      : "bg-white/[0.07] border-white/20"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                    aria-controls={`module-panel-${index}`}
                    className="w-full text-left grid grid-cols-mba-accordion-btn items-center gap-3.5 p-5"
                  >
                    <span className="font-poppins text-secondary font-extrabold text-sm">
                      0{index + 1}
                    </span>
                    <div className="grid gap-0.5">
                      <small className="font-poppins text-[#c7d0ff] uppercase tracking-wide text-xs font-semibold">
                        {module.month}
                      </small>
                      <h3 className="font-poppins text-sm font-semibold m-0">
                        {module.title}
                      </h3>
                    </div>
                    <b
                      aria-hidden="true"
                      className="w-[30px] h-[30px] rounded-full border border-white/25 text-secondary grid place-items-center text-lg font-normal"
                    >
                      {isOpen ? "−" : "+"}
                    </b>
                  </button>
                  {isOpen && (
                    <div
                      id={`module-panel-${index}`}
                      className="grid grid-cols-1 md:grid-cols-mba-panel items-end gap-5 px-5 pb-5 pl-[70px]"
                    >
                      <p className="font-poppins text-[#d5ddff] text-sm leading-relaxed m-0">
                        {module.copy}
                      </p>
                      <span className="bg-secondary/[0.12] rounded-lg px-3 py-2.5 grid gap-0.5">
                        <b className="font-poppins text-secondary uppercase tracking-wide text-xs">
                          What you produce
                        </b>
                        <span className="font-poppins text-sm">
                          {module.output}
                        </span>
                      </span>
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default MBACurriculumSection;
